import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { DualViewRef } from '../../types';
import type { DualViewRefModel } from '../dual-view-ref-model';

@injectable()
export class DualViewRefModelImpl extends AbstractModel<DualViewRef> implements DualViewRefModel {
    protected _modelData: DualViewRef = {
        left: null,
        right: null,
    };

    // 由于该数据存储的是vue的组件，无法进行解构或者clone，所以直接返回
    public clone(data: DualViewRef): DualViewRef {
        return data;
    }
}
